/*eslint-disable*/
import LeftArrowIcon from "../../assets/icons/LeftArrowIcon";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";
import Bottom from "../../components/Layouts/Bottom";
import VideoItem from "../../components/VerticalPlayer/VideoItem";
import { getVideosData } from "../../components/VerticalPlayer/helpers";
import useVerticalPlayer from "../../components/VerticalPlayer/hooks/useVerticalPlayer";
import Loader from "../../components/common/Loader";
import { CONTENT_TYPE } from "../../app/constants";
import gluedin from "gluedin-shorts-js";
import React, {
  createRef,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

const userModule = new gluedin.GluedInUserModule();
const videoModule = new gluedin.GluedInVideosModule();
const soundModule = new gluedin.GluedInSoundModule();
const activityTimelineModule = new gluedin.GluedInActivityTimeline();

const fetchHashTagVideos = async (hashtagName: any) => {
  try {
    const hashTagModule = new gluedin.GluedInHashTag();
    const {
      status,
      data: {
        result: { videos: hashTagVideos },
      },
    } = await hashTagModule.getHashTagDetails({
      limit: 10,
      offset: 1,
      name: hashtagName,
    });

    if (status === 200) {
      return hashTagVideos;
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchUserVideos = async (
  userId: any,
  offset: number,
  limit: number
) => {
  try {
    const {
      status,
      data: { result: videosList },
    } = await userModule.getUserVideoList({
      userId,
      offset,
      limit,
    });
    if (status === 200) {
      return videosList;
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchVideoById = async (contentId: any) => {
  try {
    const {
      status,
      data: { result: videoResult },
    } = await videoModule.getVideoById(contentId as string);
    if (status === 200) {
      const { videoData } = videoResult;
      return videoData;
    }
    return {};
  } catch (error) {
    console.error(error);
  }
};

const fetchVideoListBySound = async (soundId: any, page: number) => {
  try {
    const limit = 8;
    const {
      data: { statusCode, result: videosList },
    } = await soundModule.fetchVideoListBySoundId({
      limit: limit,
      offset: page || 1,
      soundId: soundId,
    });

    if (statusCode === 2004) {
      return videosList;
    }
  } catch (error) {
    console.error(error);
  }
};

const normalizeActivityVideo = (item: any) => {
  const meta = item?.metakeys ?? {};
  const merged = { ...item, ...meta };
  const videoId = meta?.videoId ?? item?.videoId ?? item?._id ?? item?.id;
  const thumbnailUrl =
    merged?.thumbnailUrl ??
    merged?.thumbnailUrls?.[0] ??
    item?.thumbnailUrl ??
    item?.thumbnailUrls?.[0];
  return {
    ...merged,
    videoId,
    thumbnailUrl,
  };
};

const fetchActivityTimelineList = async (
  event: string,
  offset: number,
  limit: number
) => {
  try {
    const { data } = await activityTimelineModule.getActivityTimelineList({
      event,
      limit,
      offset,
    });
    if (data?.statusCode === 2001) {
      return data?.result ?? [];
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const ContentDetailPage = () => {
  const defaultLanguage = localStorage.getItem("defaultLanguage");
  const { t } = useTranslation();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const contentType = searchParams.get("contentType");
  const activityTab = searchParams.get("tab") || "like";
  const offset = Number(searchParams.get("offset")) || 1;
  const profileLimit = Number(searchParams.get("limit")) || 6;
  const activityLimit = Number(searchParams.get("limit")) || 10;
  const { contentId } = useParams();
  const id = searchParams.get("clickedVideoId") || contentId;
  const [page, setPage] = useState(offset);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const videoRefs = useRef<any>(null);
  const {
    videos,
    setVideos,
    currentVideoIndex,
    setCurrentVideoIndex,
  } = useVerticalPlayer();
  const videosRef = useRef<any[]>([]);
  const loadedPagesRef = useRef<Set<number>>(new Set());
  const loadingPagesRef = useRef<Set<number>>(new Set());
  const [minPage, setMinPage] = useState(offset);
  const [maxPage, setMaxPage] = useState(offset);
  const [hasMorePrev, setHasMorePrev] = useState(offset > 1);
  const [hasMoreNext, setHasMoreNext] = useState(true);
  const [isFetchingPrev, setIsFetchingPrev] = useState(false);
  const [isFetchingNext, setIsFetchingNext] = useState(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const isFetchingPrevRef = useRef(false);
  const isFetchingNextRef = useRef(false);
  const prevEdgeActiveRef = useRef(false);
  const nextEdgeActiveRef = useRef(false);
  const hasScrolledToTarget = useRef(false);

  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    videosRef.current = videos;
  }, [videos]);

  const getVideoKey = (video: any) =>
    video?.videoId ?? video?._id ?? video?.id;

  const capturePrependScrollState = () => {
    const container = document.getElementById("vertical-player") as
      | HTMLElement
      | null;
    if (!container) return null;
    const containerRect = container.getBoundingClientRect();
    const centerX = containerRect.left + containerRect.width / 2;
    const centerY = containerRect.top + containerRect.height / 2;
    const elementAtCenter = document.elementFromPoint(
      centerX,
      centerY
    ) as HTMLElement | null;
    const anchorElement = elementAtCenter?.closest(
      "[id^='content-video-']"
    ) as HTMLElement | null;
    const anchorTop = anchorElement
      ? anchorElement.getBoundingClientRect().top - containerRect.top
      : null;
    return {
      container,
      top: container.scrollTop,
      height: container.scrollHeight,
      snapType: container.style.scrollSnapType,
      anchorId: anchorElement?.id,
      anchorTop:
        anchorTop !== null && Number.isFinite(anchorTop) ? anchorTop : null,
    };
  };

  const restorePrependScrollState = (
    scrollState: ReturnType<typeof capturePrependScrollState>
  ) => {
    if (!scrollState) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const { container, top, height, snapType } = scrollState;
        container.style.scrollSnapType = "none";
        const previousAnchorTop = scrollState.anchorTop;
        const anchorId = scrollState.anchorId;
        const nextAnchorElement = anchorId
          ? (document.getElementById(anchorId) as HTMLElement | null)
          : null;

        if (
          nextAnchorElement &&
          previousAnchorTop !== null &&
          Number.isFinite(previousAnchorTop)
        ) {
          const containerRect = container.getBoundingClientRect();
          const nextAnchorTop =
            nextAnchorElement.getBoundingClientRect().top - containerRect.top;
          const anchorDelta = nextAnchorTop - previousAnchorTop;
          container.scrollTop = top + anchorDelta;
        } else {
          const heightDelta = Math.max(container.scrollHeight - height, 0);
          container.scrollTop = top + heightDelta;
        }

        requestAnimationFrame(() => {
          container.style.scrollSnapType = snapType;
        });
      });
    });
  };

  const reindexVideos = (list: any[]) =>
    list.map((video, index) => ({
      ...video,
      indexNo: index,
      id: `${getVideoKey(video) ?? index}-${index}`,
    }));

  const loadProfilePage = async (
    pageToLoad: number,
    direction: "prev" | "next" | "initial"
  ) => {
    if (
      pageToLoad < 1 ||
      loadedPagesRef.current.has(pageToLoad) ||
      loadingPagesRef.current.has(pageToLoad)
    ) {
      return;
    }
    if (direction === "prev" && (isFetchingPrevRef.current || !hasMorePrev))
      return;
    if (direction === "next" && (isFetchingNextRef.current || !hasMoreNext))
      return;

    loadingPagesRef.current.add(pageToLoad);
    if (direction === "prev") {
      isFetchingPrevRef.current = true;
      setIsFetchingPrev(true);
    }
    if (direction === "next") {
      isFetchingNextRef.current = true;
      setIsFetchingNext(true);
    }

    try {
      const videosList =
        (await fetchUserVideos(contentId, pageToLoad, profileLimit)) || [];
      const incoming = getVideosData(videosList, 0) || [];

      loadedPagesRef.current.add(pageToLoad);

      if (!incoming.length) {
        if (direction === "prev") setHasMorePrev(false);
        if (direction === "next") setHasMoreNext(false);
        return;
      }

      const existing = videosRef.current;
      const existingKeys = new Set(
        existing.map((video: any) => getVideoKey(video)).filter(Boolean)
      );
      const uniqueIncoming = incoming.filter((video: any) => {
        const key = getVideoKey(video);
        if (!key) return true;
        if (existingKeys.has(key)) return false;
        existingKeys.add(key);
        return true;
      });

      if (!uniqueIncoming.length) return;

      const merged =
        direction === "prev"
          ? [...uniqueIncoming, ...existing]
          : [...existing, ...uniqueIncoming];
      const reindexed = reindexVideos(merged);
      const prependScrollState =
        direction === "prev" ? capturePrependScrollState() : null;

      videoRefs.current = [
        ...reindexed.map(() => createRef<HTMLVideoElement>()),
      ];
      setVideos(reindexed);

      setMinPage((prev) => Math.min(prev, pageToLoad));
      setMaxPage((prev) => Math.max(prev, pageToLoad));

      if (direction === "prev") {
        setCurrentVideoIndex((prev) => prev + uniqueIncoming.length);
        restorePrependScrollState(prependScrollState);
      }

      if (uniqueIncoming.length < profileLimit) {
        if (direction === "prev") setHasMorePrev(false);
        if (direction === "next") setHasMoreNext(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      loadingPagesRef.current.delete(pageToLoad);
      if (direction === "prev") {
        isFetchingPrevRef.current = false;
        setIsFetchingPrev(false);
      }
      if (direction === "next") {
        isFetchingNextRef.current = false;
        setIsFetchingNext(false);
      }
    }
  };

  const loadActivityPage = async (
    pageToLoad: number,
    direction: "prev" | "next" | "initial"
  ) => {
    if (
      pageToLoad < 1 ||
      loadedPagesRef.current.has(pageToLoad) ||
      loadingPagesRef.current.has(pageToLoad)
    ) {
      return;
    }
    if (direction === "prev" && (isFetchingPrevRef.current || !hasMorePrev))
      return;
    if (direction === "next" && (isFetchingNextRef.current || !hasMoreNext))
      return;

    loadingPagesRef.current.add(pageToLoad);
    if (direction === "prev") {
      isFetchingPrevRef.current = true;
      setIsFetchingPrev(true);
    }
    if (direction === "next") {
      isFetchingNextRef.current = true;
      setIsFetchingNext(true);
    }

    try {
      const activityList =
        (await fetchActivityTimelineList(
          activityTab,
          pageToLoad,
          activityLimit
        )) || [];
      const normalized = activityList.map(normalizeActivityVideo);
      const incoming = getVideosData(normalized, 0) || [];

      loadedPagesRef.current.add(pageToLoad);

      if (!incoming.length) {
        if (direction === "prev") setHasMorePrev(false);
        if (direction === "next") setHasMoreNext(false);
        return;
      }

      const existing = videosRef.current;
      const existingKeys = new Set(
        existing.map((video: any) => getVideoKey(video)).filter(Boolean)
      );
      const uniqueIncoming = incoming.filter((video: any) => {
        const key = getVideoKey(video);
        if (!key) return true;
        if (existingKeys.has(key)) return false;
        existingKeys.add(key);
        return true;
      });

      if (!uniqueIncoming.length) return;

      const merged =
        direction === "prev"
          ? [...uniqueIncoming, ...existing]
          : [...existing, ...uniqueIncoming];
      const reindexed = reindexVideos(merged);
      const prependScrollState =
        direction === "prev" ? capturePrependScrollState() : null;

      videoRefs.current = [
        ...reindexed.map(() => createRef<HTMLVideoElement>()),
      ];
      setVideos(reindexed);

      setMinPage((prev) => Math.min(prev, pageToLoad));
      setMaxPage((prev) => Math.max(prev, pageToLoad));

      if (direction === "prev") {
        setCurrentVideoIndex((prev) => prev + uniqueIncoming.length);
        restorePrependScrollState(prependScrollState);
      }

      if (uniqueIncoming.length < activityLimit) {
        if (direction === "prev") setHasMorePrev(false);
        if (direction === "next") setHasMoreNext(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      loadingPagesRef.current.delete(pageToLoad);
      if (direction === "prev") {
        isFetchingPrevRef.current = false;
        setIsFetchingPrev(false);
      }
      if (direction === "next") {
        isFetchingNextRef.current = false;
        setIsFetchingNext(false);
      }
    }
  };

  useEffect(() => {
    loadedPagesRef.current = new Set();
    loadingPagesRef.current = new Set();
    isFetchingPrevRef.current = false;
    isFetchingNextRef.current = false;
    prevEdgeActiveRef.current = false;
    nextEdgeActiveRef.current = false;
    setHasUserInteracted(false);
    setMinPage(offset);
    setMaxPage(offset);
    setHasMorePrev(offset > 1);
    setHasMoreNext(true);
    videosRef.current = [];
    setVideos([]);
    hasScrolledToTarget.current = false;
  }, [contentType, contentId, offset, activityTab]);

  useEffect(() => {
    hasScrolledToTarget.current = false;
  }, [id]);

  useEffect(() => {
    const container = document.getElementById("vertical-player");
    if (!container) return;

    const markInteracted = () => {
      setHasUserInteracted((prev) => (prev ? prev : true));
    };

    container.addEventListener("wheel", markInteracted, { passive: true });
    container.addEventListener("touchstart", markInteracted, { passive: true });
    container.addEventListener("touchmove", markInteracted, { passive: true });
    window.addEventListener("keydown", markInteracted);

    return () => {
      container.removeEventListener("wheel", markInteracted);
      container.removeEventListener("touchstart", markInteracted);
      container.removeEventListener("touchmove", markInteracted);
      window.removeEventListener("keydown", markInteracted);
    };
  }, [videos.length]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (contentType === CONTENT_TYPE.PROFILE) {
          await loadProfilePage(offset, "initial");
          return;
        }
        if (contentType === CONTENT_TYPE.ACTIVITY) {
          await loadActivityPage(offset, "initial");
          return;
        }

        let videosList = [];
        if (contentType === CONTENT_TYPE.HASHTAG) {
          videosList = await fetchHashTagVideos(contentId);
        }

        if (contentType === CONTENT_TYPE.SOUND) {
          videosList = await fetchVideoListBySound(contentId, page);
        }

        if (
          contentType === CONTENT_TYPE.SHARE ||
          contentType === CONTENT_TYPE.VIDEO
        ) {
          const videoData = await fetchVideoById(contentId);
          videosList = [videoData];
        }

        const videosData = [
          ...videosRef.current,
          ...getVideosData(videosList, videosRef.current.length),
        ];
        videoRefs.current = [
          ...videosData.map(() => createRef<HTMLVideoElement>()),
        ];
        setVideos(videosData);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, [contentType, contentId, page, offset, activityTab]);

  useEffect(() => {
    if (
      contentType !== CONTENT_TYPE.PROFILE &&
      contentType !== CONTENT_TYPE.ACTIVITY
    ) {
      return;
    }
    if (!hasUserInteracted) return;
    if (!videos.length) return;

    const loadNext =
      contentType === CONTENT_TYPE.ACTIVITY ? loadActivityPage : loadProfilePage;
    const loadPrev =
      contentType === CONTENT_TYPE.ACTIVITY ? loadActivityPage : loadProfilePage;

    const nearNextEdge = currentVideoIndex >= videos.length - 2;
    const nearPrevEdge = currentVideoIndex <= 1;

    if (!nearNextEdge) nextEdgeActiveRef.current = false;
    if (!nearPrevEdge) prevEdgeActiveRef.current = false;

    if (
      nearNextEdge &&
      !nextEdgeActiveRef.current &&
      !isFetchingNextRef.current &&
      hasMoreNext
    ) {
      nextEdgeActiveRef.current = true;
      loadNext(maxPage + 1, "next");
    }

    if (
      nearPrevEdge &&
      minPage > 1 &&
      !prevEdgeActiveRef.current &&
      !isFetchingPrevRef.current &&
      hasMorePrev
    ) {
      prevEdgeActiveRef.current = true;
      loadPrev(minPage - 1, "prev");
    }
  }, [
    contentType,
    currentVideoIndex,
    videos.length,
    minPage,
    maxPage,
    hasMorePrev,
    hasMoreNext,
    hasUserInteracted,
  ]);

  useLayoutEffect(() => {
    if (!id || !videos.length || hasScrolledToTarget.current) return;

    const normalizeKey = (value: any) =>
      value !== undefined && value !== null ? String(value) : "";
    const targetIndex = videos.findIndex(
      (video: any) => normalizeKey(getVideoKey(video)) === normalizeKey(id)
    );
    if (targetIndex < 0) return;

    setCurrentVideoIndex(targetIndex);

    const targetVideo = videos[targetIndex];
    const targetId = normalizeKey(getVideoKey(targetVideo));
    const clickedVideoElement = document.getElementById(
      `content-video-${targetId}`
    );
    if (!clickedVideoElement) return;

    const playerContainer = document.getElementById("vertical-player");
    if (playerContainer && "scrollTo" in playerContainer) {
      const container = playerContainer as HTMLElement;
      const targetWrapper = (clickedVideoElement.closest(
        ".player_item_wrapper"
      ) || clickedVideoElement) as HTMLElement;
      const previousSnapType = container.style.scrollSnapType;
      container.style.scrollSnapType = "none";
      const top = Math.max(
        targetWrapper.offsetTop -
          Math.max((container.clientHeight - targetWrapper.clientHeight) / 2, 0),
        0
      );
      container.scrollTo({
        top,
        behavior: "auto",
      });
      requestAnimationFrame(() => {
        container.style.scrollSnapType = previousSnapType;
      });
    } else {
      clickedVideoElement.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
    }
    hasScrolledToTarget.current = true;
  }, [id, videos, setCurrentVideoIndex]);

  if (!videos.length) return <Loader />;

  const loginModalHandler = () => {
    setShowLoginModal(true);
  };

  return (
    <>
      <div className="full-sec"><div className="mid-content">
          <div id="vertical-player" className="player_wrapper">
            <div className="profile-head-back">
              <div className="back-btn">
                <button className="back-btn-a" onClick={goBack}>
                  {defaultLanguage === "en" ? (
                    <LeftArrowIcon />
                  ) : (
                    <RightArrowIcon />
                  )}
                  {t("back-btn")}
                </button>
              </div>
            </div>

            {videos.map((video: any, index: number) => (
              <VideoItem
                key={video.videoId}
                ref={videoRefs.current[index]}
                video={video}
                setVideos={setVideos}
                setCurrentVideoIndex={setCurrentVideoIndex}
              />
            ))}
          </div>
        </div>
      </div>
      <Bottom />
    </>
  );
};

export default ContentDetailPage;
